const NAVIGATION_TYPES = {
    PUSH: 'PUSH',
    POP: 'POP',
    REPLACE: 'REPLACE',
} as const;

export default NAVIGATION_TYPES;
